module.exports = __webpack_public_path__ + "static/media/5.fe6f897f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/gifs/5.gif
// module id = 246
// module chunks = 0